import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Colors } from 'modules/theme';

const Wrapper = styled.span`
  display: inline-flex;
  align-items: baseline;
  line-height: 1;
  white-space: nowrap;
  color: ${({ accent }) => (accent === 'red' ? Colors.red : Colors.black2)};
`;

const Primary = styled.span`
  font-size: ${({ size }) => size}px;
  font-weight: 600;
  letter-spacing: -0.5px;
`;

const Separator = styled.span`
  font-size: ${({ size }) => Math.round(size * 0.8)}px;
  font-weight: 400;
  color: ${Colors.gray4};
  margin: 0 4px;
`;

const Secondary = styled.span`
  font-size: ${({ size }) => Math.round(size * 0.8)}px;
  font-weight: 500;
  color: ${Colors.gray};
`;

const formatNumber = n => (n == null ? '0' : Number(n).toLocaleString());

const XOverY = ({ devices, sites, size, accent }) => (
  <Wrapper accent={accent}>
    <Primary size={size}>{formatNumber(devices)}</Primary>
    <Separator size={size}>/</Separator>
    <Secondary size={size}>{formatNumber(sites)}</Secondary>
  </Wrapper>
);

XOverY.propTypes = {
  accent: PropTypes.oneOf(['default', 'red']),
  devices: PropTypes.number,
  sites: PropTypes.number,
  size: PropTypes.number,
};

XOverY.defaultProps = {
  accent: 'default',
  devices: 0,
  sites: 0,
  size: 28,
};

export default XOverY;
